const analyticsTypes = {
  BANNER_CLICK: 'Banner__Click',
  DASHBOARD_GLOBAL_BANNER_VIEW: 'dashboard_GlobalBannerView',
};

const analyticsActions = [{
  type: analyticsTypes.BANNER_CLICK
}, {
  type: analyticsTypes.DASHBOARD_GLOBAL_BANNER_VIEW
}];

export {
  analyticsTypes,
  analyticsActions
};
